<template>
    <div>
        <client-only>
            <portal to="authModal">
                <transition name="fade">
                    <div
                        key="login"
                        v-if="isShow && action === 'login'"
                        class="g-flexbox g-flex-direction-column auth-modal g-fullscreen">
                        <div class="login">
                            <div @click="close" class="g-close-btn close-btn"></div>
                            <div class="g-arrow arrow" @click="toRegister"></div>
                            <input v-model="login.account" ref="account" placeholder="请输入手机号" class="input" type="number">
                            <input v-model="login.password" placeholder="请输入密码" class="input" type="password">
                            <button @click="onLogin" class="btn">登录</button>
                        </div>
                    </div>
                    <div
                        key="register"
                        v-if="isShow && action === 'register'"
                        class="g-flexbox g-flex-direction-column auth-modal g-fullscreen">
                        <div
                            key="register"
                            class="register">
                            <div>
                                <div @click="close" class="g-close-btn close-btn"></div>
                                <div class="g-arrow arrow reverse" @click="toLogin"></div>
                                <input v-model="register.account" ref="account" placeholder="请输入手机号" class="input" type="number">
                                <sms-captcha
                                    :account="register.account"
                                    v-model="register.captcha"/>
                                <input v-model="register.userName" type="text" placeholder="用户名" class="input">
                                <input v-model="register.password" type="password" placeholder="帐号密码" class="input">
                                <button @click="onRegister" class="btn">注册</button>
                            </div>
                        </div>
                    </div>
                </transition>
            </portal>
        </client-only>
    </div>
</template>

<script>
import smsCaptcha from './sms-captcha.vue';

export default {
    data() {
        return {
            isShow: false,
            action: 'login',
            login: {
                account: '',
                password: '',
            },
            register: {
                account: '',
                captcha: '',
                userName: '',
                password: '',
            },
        };
    },
    components: {
        smsCaptcha,
    },
    methods: {
        show() {
            this.isShow = true;
            return new Promise((resolve) => {
                this.authResolve = resolve;
            });
        },
        close() {
            this.isShow = false;
        },
        onLogin() {
            this.$axios.post('/login', {
                account: this.login.account,
                password: this.login.password,
            }).then((data) => {
                this.$emit('authed');
                this.authResolve && this.authResolve({
                    uid: data.identity,
                    token: data.token,
                });
                this.$store.commit('setAuth', {
                    auth: {
                        uid: data.identity,
                        token: data.token,
                    },
                });
                this.isShow = false;
            });
        },
        onRegister() {
            this.$axios.post('/register', {
                mobile_number: this.register.account,
                sms_captcha: this.register.captcha,
                user_name: this.register.userName,
                user_password: this.register.password,
            }).then((data) => {
                this.$emit('authed');
                this.$store.commit('setAuth', {
                    auth: {
                        uid: data.identity,
                        token: data.token,
                    },
                });
                this.isShow = false;
            });
        },
        toRegister() {
            this.action = 'register';
        },
        toLogin() {
            this.action = 'login';
        },
    },
};
</script>

<style lang="scss">
.auth-modal {
    font-size: 0.16rem;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.85);
    justify-content: center;

    .close-btn {
        position: absolute;
        left: 0.1rem;
        top: 0.1rem;
        width: 0.25rem;
        height: 0.25rem;
    }

    .input,
    .btn {
        display: block;
        border: none;
        width: 2.5rem;
        color: #c0c0c0;
        background-color: rgba(255, 255, 255, .15);
        padding: .15rem .2rem;
        margin: .2rem auto;
        border-radius: .02rem;
    }

    .btn {
        background-color: rgba(255, 174, 0, .35);
        margin-bottom: 1.5rem;
    }

    .arrow {
        position: absolute;
        top: 0.2rem;
        right: 0.1rem;
        transform: scale(1.2);

        &.reverse {
            transform: scale(1.2) rotate(180deg);
        }
    }
}
</style>
